import {WorkspaceModelType} from "../stores/WorkspaceStore";

import {debounce} from "../utils/debounce";
import {LocalChangeHistory} from "./LocalChangeHistory";
import {Workspace} from "../API";
import {parseJsonOrFallback} from "../stores/convertors/parseJsonOrFallback";


export const syncWorkspaceUpdate = (workspaceMST: WorkspaceModelType, serverWorkspace: Workspace) => {
    if (!workspaceChangeHistory.isChangeLocal(serverWorkspace)) {
        workspaceMST.setChildIds(parseJsonOrFallback(serverWorkspace.childIds));
        workspaceMST.setChildArchivedIds(parseJsonOrFallback(serverWorkspace.archivedIds));
        workspaceMST.setChildTrashIds(parseJsonOrFallback(serverWorkspace.trashedIds));
        workspaceMST.setSyncedVersion(serverWorkspace.version);
    } else {
        removeStepDebounce(serverWorkspace.updatedAt!);
    }
}

export const syncWorkspaceDelete = (workspaceMST: WorkspaceModelType, serverWorkspace: Workspace) => {
}

export const workspaceChangeHistory = new LocalChangeHistory();

const removeStepDebounce = debounce(
    (step: string) => {
        workspaceChangeHistory.removeStep(step);
    },
    2000
)
